import { Grid as BaseGrid } from 'module/ui/components/atoms/grid/grid';
import { Loading } from 'module/ui/components/atoms/loading';
import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { UploadFile } from '../add-files/add-files';
import { NameCell } from './renderers/name-cell';

const Grid = styled(BaseGrid)`
  .ag-cell {
    border: none !important;
  }
  .ag-cell-focus {
    cursor: pointer;
    border: none !important;
    background-color: transparent !important;
  }
  --ag-cell-widget-spacing: 16px;
  --ag-row-group-indent-size: 16px;
`;

const GridWrapper = styled.div`
  padding: var(--spacing-03) var(--spacing-06);
  overflow: auto;
  height: 100%;
  .ag-row-group-leaf-indent.ag-row-group-indent-0 {
    padding-left: 0 !important;
  }
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

interface UploadingFilesProps {
  files: UploadFile[];
}

const uploadFilesToRowData = (files: UploadFile[]) => {
  return files.map((file) => ({
    id: file.uid,
    name: file.name,
    type: 'file',
    path: [file.uid],
  }));
};

export const UploadingFiles: FC<UploadingFilesProps> = ({ files }) => {
  const rowData = useMemo(() => {
    return uploadFilesToRowData(files);
  }, [files]);

  const colDefs = useMemo(() => {
    return [
      {
        headerName: '',
        width: 56,
        cellRenderer: () => <Loading />,
      },
    ];
  }, []);

  return (
    <Wrapper>
      <GridWrapper>
        <Grid
          rowData={rowData}
          columnDefs={colDefs}
          treeData
          getDataPath={(data: any) => data.path}
          groupDefaultExpanded={-1}
          defaultColDef={{
            filter: false,
            sortable: false,
            resizable: false,
            wrapText: true,
            suppressMovable: true,
            suppressHeaderMenuButton: true,
          }}
          domLayout="autoHeight"
          suppressContextMenu
          autoGroupColumnDef={{
            headerName: 'Uploading Files',
            flex: 1,
            cellRendererParams: {
              suppressCount: true,
              innerRenderer: NameCell,
            },
          }}
        />
      </GridWrapper>
    </Wrapper>
  );
};
